// extracted by mini-css-extract-plugin
export default {"pillContainer":"_587dd596"};